/**************************************************
 * Nombre:       Formulario_Historia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoVideo from "../../Modulo_formularios/Componentes/IngresoVideo";
import IngresoImagenLista from "../../Modulo_formularios/Componentes/IngresoImagenLista";

const Formulario_Historia = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Sube un video corto contando tu historia, no tiene que ser el mejor video nosotros lo
                        editaremos por ti</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoVideo dato={'video'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Puedes tambien subir fotos si asi lo quieres</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenLista dato={'imgs'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Historia